import Crud from '../views/Questionario/Crud'
import Entity from '../views/Questionario/Add'
import View from '../views/Questionario/View'

let routes = {
    path: '/questionario_perguntas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/questionario_perguntas/add',
            name: 'NewQuestionarioPergunta',
            component: Entity,
            meta: {
                pageTitle: 'Criação de Pergunta do Questionário',
                breadcrumb: [
                    {
                        text: 'Questionário',
                        active: false,
                        to: '/questionario_perguntas',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/questionario_perguntas/edit/:id?',
            name: 'EditQuestionarioPergunta',
            component: Entity,
            meta: {
                pageTitle: 'Edição de Pergunta do Questionário',
                breadcrumb: [
                    {
                        text: 'Questionário',
                        active: false,
                        to: '/questionario_perguntas',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/questionario_perguntas/view/:id?',
            name: 'ViewQuestionarioPergunta',
            component: View,
            meta: {
                pageTitle: 'Visualizar Pergunta do Questionário',
                breadcrumb: [
                    {
                        text: 'Questionário',
                        active: false,
                        to: '/questionario_perguntas',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/questionario_perguntas',
            name: 'list-questionario',
            component: Crud,
            meta: {
                pageTitle: 'Perguntas do Questionário',
                breadcrumb: [
                    {
                        text: 'Questionário',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
